import React, { useEffect, useState } from 'react';
import { useCart } from '../../../hooks/useCart';
import CartLineItem from './CartLineItem';
import SubscriptionUpsell from './SubscriptionUpsell';

import Money from '../../Money';
import LoadingIcon from './Loading';

import { Interweave } from 'interweave';
import Cookies from 'js-cookie/src/js.cookie';
import { initMiniCartDiscount } from '../../../../scripts/sections/cart/minicart-discount';
import getRoute from '../../../../scripts/utils/getRoute';
import useLangStrings from '../../../hooks/useLangStrings';
import { Product } from '../../../util/typings';
interface Props {
  dataSet: any;
}

const MiniCart: React.FunctionComponent<Props> = ({dataSet} : Props) => {

  const { closeMinicart, cart, items, updating } = useCart()

  const langStrings = dataSet.langStrings ? dataSet.langStrings : ''

  const countries = dataSet.countries ? dataSet.countries : ''

  const subscriptionUpsellProduct = JSON.parse(dataSet.subscriptionUpsellProduct) as Product
  const subscriptionUpsellSellingPlan = dataSet.subscriptionUpsellSellingPlan ? dataSet.subscriptionUpsellSellingPlan : ''
  const subscriptionUpsellBorder = dataSet.subscriptionUpsellBorder ? dataSet.subscriptionUpsellBorder : ''
  const subscriptionUpsellEnabled = dataSet.subscriptionUpsellEnabled ? dataSet.subscriptionUpsellEnabled : ''
  const subscriptionUpsellHeading = dataSet.subscriptionUpsellHeading ? dataSet.subscriptionUpsellHeading : ''
  const subscriptionUpsellSubtitle = dataSet.subscriptionUpsellSubtitle ? dataSet.subscriptionUpsellSubtitle : ''

  const {paymentIcons} = useLangStrings(dataSet.langStrings);

  const [isCountry, setIsCountry] = useState(true)
  const [freeGiftConfigured, setFreeGiftConfigured] = useState(false)
  const [hasFreeGiftApplied, setHasFreeGiftApplied] = useState(false)
  const [cartLangStrings, setCartLangStrings] = useState({} as Record<string, string>)
  const [hasDuplicatedParents, setHasDuplicatedParents] = useState(false)

  const openChat = e => {
    e.preventDefault()
    if(window['LC_API'] && window['LC_API'].open_chat_window) {
      closeMinicart();
      window['LC_API'].open_chat_window()
    }
  }

  useEffect(() => {
    let parsedLangsStrings = {}
    try {
      parsedLangsStrings = JSON.parse(langStrings)
    } catch (e) {
      console.info(e)
    }
    setCartLangStrings(parsedLangsStrings)

    let counter = 0;
    const interval = window.setInterval(() => {
      counter++
      if (window['blubolt'].geo) {
        const countryList = countries.split(',').map(country => country.trim())
        setIsCountry(countryList.includes(window['blubolt'].geo.handle))
        window.clearInterval(interval)
      }
      // console.log('counter', counter)
      if (counter >= 5) {
        // if global-e element not on the window after 5 seconds
        // set country to false and hide everything
        setIsCountry(false)
        window.clearInterval(interval)
      }
    }, 1000)

    let gwpCounter = 0;
    const gwpInterval = window.setInterval(() => {
      gwpCounter++
      if (window['freeCartGifts']) {
        setFreeGiftConfigured(window['freeCartGifts'].length > 0)
        window.clearInterval(gwpInterval)
      }
      // console.log('gwpCounter', gwpCounter)
      if (gwpCounter >= 5) {
        // if global-e element not on the window after 5 seconds
        // set country to false and hide everything
        setIsCountry(false)
        window.clearInterval(gwpInterval)
      }
    }, 1000)

  }, [])

  useEffect(() => {
    const valueArr = items.map(function(item){ return item.handle });
    const isDuplicate = valueArr.some(function(item, idx){
      return valueArr.indexOf(item) !== idx
    });

    if(isDuplicate) {
      setHasDuplicatedParents(true)
    } else {
      setHasDuplicatedParents(false)
    }

  }, [items])

  const hasDiscountApplied = Cookies.get('discount_code');
  const cartDiscountCodeStatus = document.querySelector('#discount-code-status') as HTMLElement;

  useEffect(() => {
    if (freeGiftConfigured) {
      initMiniCartDiscount('minicart-sidebar-discount');

      if (hasDiscountApplied && cartDiscountCodeStatus) {
        // console.log('hasDiscountApplied: ' + hasDiscountApplied)
        const applyBtn = document.querySelector('#apply-discount-btn');

        if (applyBtn) {
          applyBtn.setAttribute('disabled', 'true')
        }
        if (cartDiscountCodeStatus) {
          cartDiscountCodeStatus.style.display = 'flex';
        }
      }
      const checkIfHasFreeGiftApplied = items.some(p => p.properties && Object.keys(p.properties).includes('_free_gift'))
      setHasFreeGiftApplied(checkIfHasFreeGiftApplied)
    }
  }, [freeGiftConfigured])

  let showSubscriptionUpsell = true;
  /* hide upsells if there are no items in the cart OR if the user is not in the UK see https://blubolt.teamwork.com/app/tasks/38764047 */
  if (window.Shopify.country !== 'GB') {
    showSubscriptionUpsell = false;
  } else if (items.filter(e => e['handle'] === subscriptionUpsellProduct.handle).length > 0) {
    showSubscriptionUpsell = false;
  } else {
    showSubscriptionUpsell = true;
  }

  let totalDiscount = cart.total_discount;
  let totalPrice = cart.total_price;
  if (freeGiftConfigured && localStorage.getItem('discountAmount')) {
    totalDiscount = parseInt(localStorage.getItem('discountAmount'));
    totalPrice -= totalDiscount;
    const cartTotal = document.querySelector('[data-ge-basket-producttotalprice]') as HTMLElement;
    const cartDiscountContainer = document.querySelector('#cart-discount-amount') as HTMLElement;
    const cartDiscount = document.querySelector('[data-ge-basket-productdiscountsprice]') as HTMLElement;
    const minicartTotal = document.querySelector('[data-ge-basket-totals] > span');
    const minicartDiscount = document.querySelector('[data-minicart-discount] > span');

    if (cartDiscountContainer && minicartDiscount && window.Shopify.currency.active === 'GBP') {
      cartDiscountContainer.style.display = 'flex';
      cartDiscount.innerHTML = minicartDiscount.innerHTML;
    }

    if (cartTotal && minicartTotal && window.Shopify.currency.active === 'GBP') {
      cartTotal.innerHTML = minicartTotal.innerHTML;
    }
  }

  useEffect(() => {
    if(window['hextom_fsb']) {
      window['hextom_fsb']()
    }
  }, [isCountry])

  const { title, summaryTitle, dupedItems, dupedItemsChat, removeText, orderTitle, itemsText, savingTitle, subTotalTitle, proccedCta, viewCartCta, salePoint1Html, salePoint2Html, salePoint3Html, notReserved, soldOut, addToCart, discountTitle, applyDiscount, cartDiscountSuccessMsg, freeGiftMessage, freeGiftInfo } = cartLangStrings;

  return (
    <>
      <button tabIndex={-1} onClick={closeMinicart} aria-label="Close" className="minicart-underlay"></button>
      <aside className="minicart" aria-labelledby="minicart-title">
        <header className="minicart-header">
          <h4 id="minicart-title" className="minicart-title heading-2">{ title } { updating ? (<LoadingIcon />) : '' }</h4>
          <button className="minicart-close-button" onClick={ closeMinicart }>&times;</button>
          {hasDuplicatedParents ?
            <div className="minicart-duped-items"><Interweave content={dupedItems} noWrap={true} /> <a href="/" onClick={openChat}>{dupedItemsChat}</a></div>
            : ''}

          { isCountry ?
            <div id="fsb_placeholder"></div>
            : ''}
        </header>
        <div className="minicart-scroll-area">
          <div className="minicart-scroll-area-inner">
            <div className="minicart-main">
              <div className="minicart-items">
                <ul className="minicart-items-list">
                  {items.map(lineItem =>
                    <CartLineItem langStrings={{ removeText: removeText, freeGiftMessage: freeGiftMessage }} key={lineItem.key} lineItem={lineItem}></CartLineItem>
                  )}
                </ul>
              </div>
              <div className="reserved-message">
                <p>{ notReserved }</p>
              </div>

              { isCountry && subscriptionUpsellSellingPlan !== null ?
                <div id="minicart-subscription-plan" data-subscription-upsell-plan={ subscriptionUpsellSellingPlan }></div>
                : ''}

              { isCountry && showSubscriptionUpsell && subscriptionUpsellEnabled !== 'false' ?
                <div className="minicart-subscription-upsell">
                  <SubscriptionUpsell
                    langStrings={{ soldOut: soldOut, addToCart: addToCart }}
                    subscriptionUpsellSellingPlan={ subscriptionUpsellSellingPlan }
                    subscriptionUpsellProduct={ subscriptionUpsellProduct }
                    subscriptionUpsellHeading={ subscriptionUpsellHeading }
                    subscriptionUpsellSubtitle={ subscriptionUpsellSubtitle }
                    subscriptionUpsellBorder={ subscriptionUpsellBorder }
                  ></SubscriptionUpsell>
                </div>
                : ''}
              {freeGiftConfigured ?
                <div className="minicart-sidebar-discount">
                  <h3 className="minicart-sidebar-discount__title">{ discountTitle }</h3>
                  <div className="minicart-sidebar-discount__inner">
                    <input type="text" id="minicart-discount-code" className="text-input minicart-discount-code uc-text" autoComplete="off" placeholder="Enter discount code" />
                    { hasDiscountApplied ?
                      <button className="btn btn--primary" id="apply-discount-minicart-btn" disabled>{ applyDiscount }</button>
                      : <button className="btn btn--primary" id="apply-discount-minicart-btn">{ applyDiscount }</button>
                    }
                  </div>
                  { hasDiscountApplied ?
                    <span id="minicart-discount-code-status" className="minicart-dicount-code-status">{ cartDiscountSuccessMsg }</span>
                    : <span id="minicart-discount-code-status" className="minicart-dicount-code-status"></span>
                  }
                </div>
                : '' }
            </div>

            <footer className="minicart-summary">
              <div className="minicart-summary-title heading-3">{ summaryTitle }</div>
              { /* only show discount subtotals on UK site */ }
              { totalDiscount > 0 ?
                <>
                  <div className="minicart-footer-line">
                    <span>{ orderTitle } ({cart.item_count} {itemsText})</span><span data-ge-basket-subtotals><Money amount={hasFreeGiftApplied ? cart.total_price : cart.original_total_price} /></span>
                  </div>
                  <div className="minicart-footer-line savings">
                    {hasFreeGiftApplied ?
                      (<span>{ freeGiftInfo }</span>)
                      : (<>

                        <span><Interweave content={savingTitle} noWrap={true} /></span>
                        <span data-ge-basket-productdiscountsprice data-minicart-discount><Money amount={totalDiscount} /></span>
                      </>)
                    }
                  </div>
                </>
                : null}
              <div className="minicart-footer-line minicart-totals">
                <span>{subTotalTitle}</span><span className="minicart-total-price" data-ge-basket-totals><Money amount={totalPrice} /></span>
              </div>
              <div className="minicart-ctas">
                <a href={`${getRoute()}checkout`} data-ge-checkout-button className="btn minicart-cta">{proccedCta}</a>
                <a href={`${getRoute()}cart`} className="btn-2 minicart-cta">{viewCartCta}</a>
              </div>

              { paymentIcons ? (<div className="minicart-payment-icons" dangerouslySetInnerHTML={{ __html: paymentIcons }}/>) : null }

              <div className="minicart-additional-text rte">
                { salePoint1Html ? (<p><Interweave content={salePoint1Html} noWrap={true} /></p>) : null }
                { salePoint2Html ? (<p><Interweave content={salePoint2Html} noWrap={true} /></p>) : null }
                { salePoint3Html ? (<p><Interweave content={salePoint3Html} noWrap={true} /></p>) : null }
              </div>
            </footer>
          </div>
        </div>
      </aside>
    </>
  )
}

export default MiniCart
